<template>
  <div id="global-search">
    <input
      ref="inputSearch"
      type="text"
      v-model="inputText"
      @focus="toggleInput()"
      @keyup="searching"
      data-action="start_search"
    />
    <span class="icon-search">
      <i class="far fa-search"></i>
    </span>
    <span v-if="inputText" class="icon-clear" @click="clearText()" data-action="clear_search">
      <i class="fas fa-times-circle"></i>
    </span>
  </div>
</template>
<script>
import GlobalSearchFunction from "../../mixins/global-search-function";

export default {
  props: {
    textSearching: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      inputText: ""
    };
  },
  mixins: [GlobalSearchFunction],
  watch: {
    $route() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$route.query.toggleSearch ? this.$refs.inputSearch.focus() : null;
        });
      }, 500);
    },
    textSearching() {
      this.inputText = this.textSearching;
    },
    async inputText(value) {
      if (value) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$emit("isLoading", true);
          clearTimeout(this.timer);
          this.timer = setTimeout(async () => {
            this.$emit("update:text-searching", this.inputText);
            await this.mixins_global_search_getSearchAllFunction(value);
            this.$emit(
              "mixins_global_search_orderSearchScore",
              this.mixins_global_search_orderSearchScore
            );
            this.$emit(
              "mixins_global_search_searchResults",
              this.mixins_global_search_searchResults
            );
            this.$emit(
              "mixins_global_search_allTab_notFound",
              this.mixins_global_search_allTab_notFound
            );
            this.$emit("isLoading", false);
          }, 200);
        }, 500);
      }
    }
  },
  mounted() {
    this.$route.query.toggleSearch ? this.$refs.inputSearch.focus() : null;
  },
  methods: {
    toggleInput() {
      this.$emit("toggle-search", true);
    },
    searching() {
      this.inputText.length > 0
        ? this.$emit("is-searching", true)
        : this.$emit("is-searching", false);
    },
    clearText() {
      this.inputText = "";
      this.$emit("update:text-searching", this.inputText);
      this.$emit("is-searching", false);
    }
  }
};
</script>
<style lang="scss" scoped>
#global-search {
  border-radius: 20px;
  background-color: #fdfdfd;
  position: relative;
  height: 40px;
  /* border-radius */
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  /* box-shadow */
  box-shadow: 0 2px 6px 0 rgba(186, 186, 186, 0.24);
  input {
    border: none;
    padding: 5px 40px;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    background: none;
    @extend %font-size-m;
  }
  .icon-search {
    color: $color-secondary-text;
    position: absolute;
    left: 16px;
    top: 7px;
    i {
      font-size: 12px;
    }
  }
  .icon-clear {
    display: block;
    color: $color-secondary-text;
    position: absolute;
    right: 16px;
    top: 5px;
    i {
      font-size: 12px;
    }
  }
}
</style>